import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';
import TextArea from 'commons/TextArea';
import useUserProfile from 'hooks/useUserProfile';
import SectionWrapper from 'pages/EditArtistProfile/commons/SectionWrapper';
import { ToastTopHelper } from 'utils/utils';

import useStyles from './styles';

const AboutArtist = ({ userProfile, onUpdateUserProfile }) => {
  const [aboutArtist, setAboutArtist] = useState();
  const { updateUserProfile } = useUserProfile();
  const [error, setError] = useState();

  const classes = useStyles();
  const { t } = useTranslation();

  const handleStatementChange = (e) => {
    const { value } = e.target;
    setAboutArtist(value);
    setError(value?.length >= 10001);
  };

  const handleUpdateSuccess = () => {
    onUpdateUserProfile();
    ToastTopHelper.success(t('update_successfully'));
  };

  const validate = () => {
    const disabled = JSON.stringify(userProfile?.about_artist) === JSON.stringify(aboutArtist);
    if (disabled) {
      return false;
    }
    if (error) {
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }
    const updateData = {
      about_artist: aboutArtist,
    };
    updateUserProfile(updateData, handleUpdateSuccess);
  };

  useEffect(() => {
    if (userProfile) {
      setAboutArtist(userProfile?.about_artist);
    }
  }, [userProfile]);

  return (
    <SectionWrapper heading={t('about_artist')}>
      <Text mt={16}>{t('description')}</Text>

      <TextArea
        value={aboutArtist}
        onChange={handleStatementChange}
        maxLength={10001}
        textMaxLength={10000}
        placeholder={t('text_placeholder_about_artist')}
        helperText={error && t('text_max_length_error', { length: 10000 })}
        error={error}
      />

      <Button
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleSubmit}
        disabled={!validate()}
        className={classes.btnSubmit}
      >
        {t('save')}
      </Button>
    </SectionWrapper>
  );
};

export default AboutArtist;
